import { Component, OnInit } from '@angular/core';
import { Platform, ModalController } from 'ionic-angular';

import { NavController } from 'ionic-angular';
declare var window: any;
import { ecgDataService, ContactPage} from "../contact/contact"
import {HomePage} from "../home/home"

export enum enumConnectionMode { 'BLE', 'WIF' };
export class settingModel {
    connectionMode: enumConnectionMode = enumConnectionMode.WIF;
    autoStop: number = 2;
    adu: number = 100;
    sr: number = 100;
    lead: number = 1;
}
@Component({
    selector: 'settings',
    templateUrl: 'settings.html'
})
export class settingsPage {
    dataserverIp: string="192.168.5.13";
    dataserverPort: number = 23
    setting: settingModel = new settingModel();
    keys(): Array<string> {
        var keys = Object.keys(enumConnectionMode);
        return keys.slice(keys.length / 2);
    }
    constructor(
        public navCtrl: NavController,
        public platform: Platform,
        public modalCtrl: ModalController,
        public _ecgDataService: ecgDataService
    ) {

    }
    ngOnInit() {

    }
    saveForm() {
        this._ecgDataService.dataServerIp = this.dataserverIp;
        this._ecgDataService.dataServerPort = this.dataserverPort;
        this.navCtrl.push(ContactPage);
    }
    discover() {
        let modal = this.modalCtrl.create(HomePage);
        modal.present();
    }
}


// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts